import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { createQueryKey, storage } from '@hero/utils';

import { organizationServices } from '../../index';

export const useGetUser = (options = {}) => {
  const userToken = storage.getUserToken();

  return useQuery(createQueryKey(QUERY_KEYS.useGetUserKey), () => organizationServices.getUser(), {
    ...options,
    enabled: !!userToken && !options?.enabled,
    cacheTime: Infinity,
    staleTime: Infinity
  });
};
